import { Injectable } from '@angular/core';
import { BehaviorSubject, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class sidebarTogglerService {
  private isSidebarSubject = new BehaviorSubject<boolean>(false);

  isSidebarSubject$ = this.isSidebarSubject.asObservable().pipe(shareReplay(1));
  setSidaBarState(state: boolean) {
    this.isSidebarSubject.next(state);
  }

}